<template>
    <section>
        <sy-baselist
                :filters="filters"
                hideAdd
                hideDel
                editVue="./system/System_Edit.vue"
                listUrl="server/system/System.ashx?cmd=GetList"
                :fixWhere="fixWhere"
        >
            <el-table-column prop="systemKey" label="参数名" width="200" sortable>
            </el-table-column>
            <el-table-column prop="systemValue" label="参数值" width="400" sortable>
            </el-table-column>
            <el-table-column prop="note" label="备注" width="200" sortable>
            </el-table-column>

        </sy-baselist>
    </section>
</template>

<script>
    import util from '../../common/util'
    import mixin from '../../common/mixin'
    export default {
        mixins: [mixin],
        data(){
            return {
                filters: [{type: "string",name:"systemKey",text:"参数名", value: ""}],
                fixWhere:'',
            }
        },
        methods:{
            init(){
                if(global.nowPath=="/benfit-setting")
                {
                    this.fixWhere='systemType=1'

                }else {
                    this.fixWhere=''
                }
            }
        },
        watch: {
            '$route' (to, from) {
                // 对路由变化作出响应...
                this.init()
            }
        },
        created(){
            this.init()
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/system/System.vue